import { createFileRoute } from "@tanstack/react-router";
import { ChecklistPage } from "@/features/checklist/checklist-page";

export const Route = createFileRoute("/app/w/$weddingId/checklist")({ component: ChecklistPage });
